<template>
  <v-container>
    <v-layout justify-center>
      <v-flex xs12>
        <v-card>
          <l-data-table
            :headers="(config.needReview===true)?header_2:header"
            :get-data-func="getVisitorList"
            @click:row="getDetails($event.item)"
            init-sort-by="visitorVeCode"
            item-key="visitorVeCode"
            :selectable="config.needReview===true"
            clickable
            hide-refresh
            v-model="selected"
            ref="visitorList">
            <template slot="title">
              <span>{{reservationName}}</span>
              <span class="ml-4"> 登记上限：{{config.maxAppl}}</span>
              <span class="ml-2">当前登记:{{config.maxAppl-config.curAppl}}</span>
              <span class="ml-2">尚可登记:{{config.curAppl}} </span>
            </template>
            <template slot="title-search">
              <v-layout>
                <v-text-field v-model="carSearch" placeholder="请输入车牌号进行搜索"></v-text-field>
                <v-btn icon @click="refreshList">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-menu  left v-if="config.needReview">
                  <v-btn slot="activator" icon>
                    <v-icon  small>$vuetify.icons.more</v-icon>
                  </v-btn>
                  <v-list dense>
                    <v-list-tile @click="reviewVehicles(selected)" :disabled="selected.length===0">
                      <v-list-tile-title class="pr-1">
                        批量审核
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-layout>
            </template>
            <template slot="row-action" slot-scope="{item}">
              <td @click.stop class="px-0 mx-0 text-xs-center">
                <v-menu  left>
                  <v-btn slot="activator" icon small>
                    <v-icon  small>$vuetify.icons.more</v-icon>
                  </v-btn>
                  <v-list dense>
                    <v-list-tile @click="editVehicle(item)">
                      <v-list-tile-title class="pr-1">
                        编辑
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="deleteVehicleConfirm(item)">
                      <v-list-tile-title class="pr-1">
                        删除
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="reviewVehicles(item)" v-if="config.needReview" :disabled="item.reviewStatus!==0">
                      <v-list-tile-title class="pr-1">
                        审核
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </td>
            </template>
          </l-data-table>
        </v-card>
        <v-dialog
          v-model="visitorDialog"
          width="800"
          persistent>
          <v-layout column>
            <v-card>
              <v-card-title class="primary white--text">
                <span v-if="status==='add'" style="font-size: 16px">新增访客</span>
                <span v-else style="font-size: 16px">访客编辑</span>
                <v-spacer></v-spacer>
                <v-btn icon @click="visitorDialog=false">
                  <v-icon>$vuetify.icons.close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-form ref="visitorForm">
                  <l-plate-picker
                    v-model="visitorForm.visitorVeCode"></l-plate-picker>
                  <v-text-field
                    label="访客手机"
                    v-model="visitorForm.visitorPhone"
                    prepend-icon="mdi-phone"
                    :rules="$rules.phone11()"
                  ></v-text-field>
                  <v-text-field
                    label="访客姓名"
                    v-model="visitorForm.visitorName"
                    prepend-icon="mdi-account"
                    :rules="(config.veSelfRegRule.name===true)?[$rules.requiredS()]:[]"
                  ></v-text-field>
                  <v-text-field
                    label="访客单位"
                    prepend-icon="mdi-account-group"
                    v-model="visitorForm.visitorOrg"
                    :rules="(config.veSelfRegRule.org===true)?[$rules.requiredS()]:[]"
                  ></v-text-field>
                  <v-select
                    label="证件类型"
                    v-model="visitorForm.visitorIdType"
                    :items="visitorTypeSelect"
                    :rules="(config.veSelfRegRule.idType===true)?[$rules.requiredS()]:[]"
                    item-text="text"
                    item-value="text"
                    prepend-icon="mdi-account-box"
                  ></v-select>
                  <v-text-field
                    label="证件号码"
                    prepend-icon="mdi-account-card-details"
                    v-model="visitorForm.visitorIdNum"
                    :rules="(config.veSelfRegRule.id===true)?[$rules.requiredS()]:[]"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-layout justify-center>
                  <v-btn class="info" @click="(status==='add')?addSave():editSave()">确认</v-btn>
                  <v-btn class="error" @click="visitorDialog=false">取消</v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-layout>
        </v-dialog>
        <v-dialog
          v-model="reviewForm.vehicleDialog"
          width="800"
          persistent>
          <v-layout column>
            <v-card>
              <l-data-table
                :headers="reviewForm.reviewHeader"
                :items="reviewForm.selectVehicles"
                hide-title-search
                hide-refresh
                title-text="待审核车辆列表"></l-data-table>
              <v-layout justify-center>
                <v-btn class="primary" @click="reviewVehiclesFin(reviewForm.selectVehicles,1)" :loading="loading" :disabled="disabledFlag">通过</v-btn>
                <v-btn class="error" @click="reviewVehiclesFin(reviewForm.selectVehicles,-1)" :loading="loading" :disabled="disabledFlag">拒绝</v-btn>
                <v-btn class="warning" @click="reviewForm.vehicleDialog=false" :loading="loading" :disabled="disabledFlag">取消</v-btn>
              </v-layout>
            </v-card>
          </v-layout>
        </v-dialog>
      </v-flex>
    <!--  <l-fixed-btn
        @click="addVehicle()"
        icon="$vuetify.icons.add"
      ></l-fixed-btn>-->
    </v-layout>
    <!--<v-layout class="my-5" justify-center>
      <v-progress-circular color="primary" indeterminate size="60"></v-progress-circular>
    </v-layout>-->
  </v-container>
</template>
<script>
import LDataTable from '../../../ladmin/components/LDataTable/LDataTable'
import LPlatePicker from '../../../components/LPlatePicker'
export default {
  name: 'selfSignList',
  components: {LDataTable, LPlatePicker},
  props: {
    config: {
      type: Object,
      required: true
    },
    reservationName: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      selected: [],
      filterItems: [],
      loading: false,
      disabledFlag: false,
      header: [
        {text: '访客车牌', align: 'left', value: 'visitorVeCode', sortable: true},
        {text: '访客手机', align: 'left', value: 'visitorPhone', sortable: false},
        {text: '访客姓名', align: 'left', value: 'visitorName', sortable: false},
        {text: '访客单位', align: 'left', value: 'visitorOrg', sortable: false},
        {text: '证件号码', align: 'left', value: 'visitorIdNum', sortable: false},
        {text: '证件类型', align: 'left', value: 'visitorIdType', sortable: false},
        {text: '', align: 'left', sortable: false}
      ],
      header_2: [
        {text: '访客车牌', align: 'left', value: 'visitorVeCode', sortable: true},
        {text: '访客手机', align: 'left', value: 'visitorPhone', sortable: false},
        {text: '访客姓名', align: 'left', value: 'visitorName', sortable: false},
        {text: '访客单位', align: 'left', value: 'visitorOrg', sortable: false},
        {text: '证件号码', align: 'left', value: 'visitorIdNum', sortable: false},
        {text: '证件类型', align: 'left', value: 'visitorIdType', sortable: false},
        {text: '审核状态', align: 'left', value: 'reviewStatus', sortable: false, f: v => v === 0 ? '未审核' : (v === 1) ? '审核通过' : '审核拒绝'},
        {text: '', align: 'left', sortable: false}
      ],
      visitorForm: {
        visitorVeCode: '',
        visitorPhone: '',
        visitorName: '',
        visitorOrg: '',
        visitorIdNum: '',
        visitorIdType: ''
      },
      visitorTypeSelect: [
        {
          text: '居民身份证',
          value: 'idCard'
        },
        {
          text: '军官证|警官证|士兵证',
          value: 'osCard'
        },
        {
          text: '护照',
          value: 'passport'
        },
        {
          text: '港澳|台湾居民来往内地通行证',
          value: 'mtPermit'
        }
      ],
      moreActions: [
        {
          event: 'edit',
          label: '编辑',
          icon: ''
        },
        {
          event: 'delete',
          label: '删除',
          icon: ''
        },
      ],
      status: 'add',
      // 车辆详细信息
      detailsDialog: {
        activate: false,
        item: {}
      },
      visitorDialog: false,
      curVisitor: {},
      carSearch: '',
      reviewForm: {
        selectVehicles: [],
        vehicleDialog: false,
        reviewHeader: [
          {text: '访客车牌', align: 'left', value: 'visitorVeCode', sortable: true},
          {text: '访客手机', align: 'left', value: 'visitorPhone', sortable: false},
          {text: '', align: 'left', value: '', sortable: false},
        ]
      }
    }
  },
  created () {
    // this.config = this.$route.params.config
    // this.reservationName = this.$route.query.name
    console.log(this.config)
  },
  activated () {
    /* this.config = this.$route.params.config
    this.reservationName = this.$route.query.name
    console.log(this.config) */
  },
  methods: {
    async getVisitorList ({pagination, sortStack, filterItems, search}) {
      if (this.carSearch !== '') {
        return this.searchCar()
      }
      this.loading = true
      let res = await this.$store.dispatch('letterReservation/selfSign_getVisitorList', {pagination: pagination, procInstId: this.$route.query.id})
      this.loading = false
      // console.log(res)
      if (res.data.code + '' === '200') {
        // console.log(res.data.data)
        return {items: (res.data.data === null) ? [] : res.data.data.dataDetails, amount: (res.data.data === null) ? 0 : parseInt(res.data.data.dataSize)}
      }
      else {
        this.$L.alert('error', {message: '查询访客车辆列表信息错误，原因：' + res.data.msg})
      }
    },
    editVehicle (item) {
      this.status = 'edit'
      this.visitorDialog = true
      this.curVisitor = item
      this.visitorForm.visitorVeCode = item.visitorVeCode
      this.visitorForm.visitorPhone = item.visitorPhone
      this.visitorForm.visitorIdNum = item.visitorIdNum
      this.visitorForm.visitorIdType = item.visitorIdType
      this.visitorForm.visitorOrg = item.visitorOrg
      this.visitorForm.visitorName = item.visitorName
    },
    async editSave () {
      if (this.$refs.visitorForm.validate()) {
        let config = {
          'formKey': 'spava_pass-control_form_act-cfg',
          'procInstId': this.$route.query.id,
          'updateVelInFormList': [
            {
              'originVel': this.curVisitor.visitorVeCode,
              'updatedVel': this.visitorForm.visitorVeCode,
              'updatedPhone': this.visitorForm.visitorPhone,
              'updatedCampus': this.visitorForm.visitorOrg,
              'updatedName': this.visitorForm.visitorName,
              'updateIdNum': this.visitorForm.visitorIdNum,
              'updateIdType': this.visitorForm.visitorIdType
            }
          ]
        }
        let res = await this.$store.dispatch('letterReservation/selfSign_editVisitor', config)
        if (res.data.code + '' === '200') {
          this.$L.alert('success', {message: '保存编辑成功'})
          this.visitorDialog = false
          this.$refs.visitorList.refresh()
        }
        else {
          this.$L.alert('error', {message: '保存失败,原因:' + res.data.msg})
          this.visitorDialog = false
        }
      }
      else {
        this.$L.alert('error', {message: '表单数据不合法'})
      }
    },
    async deleteVehicleConfirm (item) {
      let {res, close} = await this.$L.confirm({
        title: '确认删除该车辆？',
        text: '车辆号牌:' + item.visitorVeCode
      })
      if (res) {
        try {
          await this.deleteVehicle(item)
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async deleteVehicle (item) {
      let obj = {
        'formKey': 'spava_pass-control_form_act-cfg',
        'procInstId': this.$route.query.id,
        'velInFormList': [
          item.visitorVeCode.toString()
        ]
      }
      let res = await this.$store.dispatch('letterReservation/selfSign_deleteVisitor', obj)
      if (res.data.code + '' === '200') {
        this.$L.alert('success', {message: '删除成功'})
        this.config.curAppl++
        this.$refs.visitorList.refresh()
      }
      else {
        this.$L.alert('error', {message: '删除失败，原因:' + res.data.msg})
      }
    },
    async addSave () {
      if (this.$refs.visitorForm.validate()) {
        let config = {
          'formKey': 'spava_pass-control_form_act-cfg',
          'procInstId': this.$route.query.id,
          'updateVelInFormList': [
            {
              'updatedVel': this.visitorForm.visitorVeCode,
              'updatedPhone': this.visitorForm.visitorPhone,
              'updatedCampus': this.visitorForm.visitorOrg,
              'updatedName': this.visitorForm.visitorName,
              'updateIdNum': this.visitorForm.visitorIdNum,
              'updateIdType': this.visitorForm.visitorIdType
            }
          ]
        }
        let res = await this.$store.dispatch('letterReservation/selfSign_addVisitor', config)
        if (res.data.code + '' === '200') {
          this.$L.alert('success', {message: '添加成功'})
          this.$refs.visitorList.refresh()
          this.visitorDialog = false
          this.config.curAppl--
        }
        else {
          this.$L.alert('error', {message: '添加失败,原因:' + res.data.msg})
          this.visitorDialog = false
        }
      }
      else {
        this.$L.alert('error', {message: '表单数据不合法'})
      }
    },
    addVehicle () {
      this.status = 'add'
      this.visitorDialog = true
      this.curVisitor = {}
      this.visitorForm.visitorVeCode = ''
      this.visitorForm.visitorPhone = ''
      this.visitorForm.visitorIdNum = ''
      this.visitorForm.visitorIdType = ''
      this.visitorForm.visitorOrg = ''
      this.visitorForm.visitorName = ''
    },
    async searchCar () {
      let config = {
        'formKey': 'spava_pass-control_form_act-cfg',
        'procInstId': this.$route.query.id,
        'velInForm': this.carSearch
      }
      let res = await this.$store.dispatch('letterReservation/selfSign_searchVisitor', config)
      if (res.data.code + '' === '200') {
        let list = []
        list.push(res.data.data)
        return {items: list, amount: list.length}
      }
      else {
        this.$L.alert('error', {message: res.data.msg})
      }
    },
    getDetails (item) {
      // console.log(item)
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({
          name: 'VehicleStatisticDetails',
          params: {
            plate: item.visitorVeCode,
          },
        })
      }
    },
    reviewVehicles (item) {
      this.reviewForm.vehicleDialog = true
      this.reviewForm.selectVehicles = []
      if (item.constructor === Object) {
        if (item.reviewStatus === 0) {
          this.reviewForm.selectVehicles.push(item)
        }
      }
      else if (item.constructor === Array) {
        for (let i = 0; i < item.length; i++) {
          if (item[i].reviewStatus === 0) {
            this.reviewForm.selectVehicles = item
          }
        }
      }
    },
    async reviewVehiclesFin (items, status) {
      let array = []
      for (let i = 0; i < items.length; i++) {
        array.push(items[i].visitorVeCode)
      }
      this.loading = true
      this.disabledFlag = true
      let res = await this.$store.dispatch('letterReservation/reviewVehicles', {array: array, status: status, procInstId: this.$route.query.id})
      this.disabledFlag = true
      this.loading = false
      if (res.data.code + '' === '200') {
        this.$L.alert('success', {message: '审核完成'})
        this.reviewForm.vehicleDialog = false
        this.refreshList()
      }
      else {
        this.$L.alert('error', {message: '审核失败，原因：' + res.data.msg})
      }
    },
    refreshList () {
      this.$refs.visitorList.refresh()
    }
  },
}
</script>
